import { useState, useCallback } from "react";
import { cards } from "./terminalData";
import {
  clearPendingVerification,
  readPendingVerification,
  writePendingVerification,
} from "./verifyStorage";

export default function useModals() {
  const [openEbookModal, setOpenEbookModal] = useState(false);
  const [openGetDemoModal, setOpenGetDemoModal] = useState(false);
  const [openCalendlyModal, setOpenCalendlyModal] = useState(false);
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [loginModalTitle, setLoginModalTitle] = useState("");
  const [openRegisterModal, setOpenRegisterModal] = useState(false);
  const persisted = readPendingVerification();
  const [openVerifyEmailModal, setOpenVerifyEmailModal] = useState(
    Boolean(persisted?.email),
  );
  const [pendingVerificationEmail, setPendingVerificationEmailState] = useState(
    persisted?.email || "",
  );
  const [openForgotPasswordModal, setOpenForgotPasswordModal] = useState(false);
  const [openChangeEmailModal, setOpenChangeEmailModal] = useState(false);
  const [changeEmailContext, setChangeEmailContext] = useState({
    currentEmail: "",
  });
  const [openPartnerModal, setOpenPartnerModal] = useState(false);
  const [openClientSetupModal, setOpenClientSetupModal] = useState(false);
  const [clientSetupContext, setClientSetupContext] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const setPendingVerificationEmail = useCallback((email) => {
    setPendingVerificationEmailState(email || "");
    if (email) {
      writePendingVerification(email);
    } else {
      clearPendingVerification();
    }
  }, []);

  // Optional convenience functions
  const openModal = useCallback((type, options = {}) => {
    if (type === "ebook") setOpenEbookModal(true);
    if (type === "getDemo") setOpenGetDemoModal(true);
    if (type === "calendly") setOpenCalendlyModal(true);
    if (type === "login") {
      setLoginModalTitle(options.title || "");
      setOpenLoginModal(true);
    }
    if (type === "register") setOpenRegisterModal(true);
    if (type === "verifyEmail") setOpenVerifyEmailModal(true);
    if (type === "forgotPassword") setOpenForgotPasswordModal(true);
    if (type === "changeEmail") setOpenChangeEmailModal(true);
    if (type === "partner") setOpenPartnerModal(true);
    if (type === "clientSetup") setOpenClientSetupModal(true);
  }, []);

  const closeModal = useCallback((type) => {
    if (type === "ebook") setOpenEbookModal(false);
    if (type === "getDemo") setOpenGetDemoModal(false);
    if (type === "calendly") setOpenCalendlyModal(false);
    if (type === "login") {
      setOpenLoginModal(false);
      setLoginModalTitle("");
    }
    if (type === "register") setOpenRegisterModal(false);
    if (type === "verifyEmail") setOpenVerifyEmailModal(false);
    if (type === "forgotPassword") setOpenForgotPasswordModal(false);
    if (type === "changeEmail") setOpenChangeEmailModal(false);
    if (type === "partner") setOpenPartnerModal(false);
    if (type === "clientSetup") setOpenClientSetupModal(false);
  }, []);

  const closeAll = useCallback(() => {
    setOpenEbookModal(false);
    setOpenGetDemoModal(false);
    setOpenCalendlyModal(false);
    setOpenLoginModal(false);
    setLoginModalTitle("");
    setOpenRegisterModal(false);
    setOpenVerifyEmailModal(false);
    setOpenForgotPasswordModal(false);
    setOpenChangeEmailModal(false);
    setOpenPartnerModal(false);
    setOpenClientSetupModal(false);
    setPendingVerificationEmail("");
    setIsModalOpen(false);
    setSelectedCard(null);
  }, [setPendingVerificationEmail]);

  const handleOpenModal = (id) => {
    const card = cards.find((c) => c.id === id);
    setSelectedCard(card);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCard(null);
  };

  return {
    openEbookModal,
    setOpenEbookModal,
    openGetDemoModal,
    setOpenGetDemoModal,
    openCalendlyModal,
    setOpenCalendlyModal,
    openLoginModal,
    setOpenLoginModal,
    loginModalTitle,
    setLoginModalTitle,
    openRegisterModal,
    setOpenRegisterModal,
    openVerifyEmailModal,
    setOpenVerifyEmailModal,
    pendingVerificationEmail,
    setPendingVerificationEmail,
    openForgotPasswordModal,
    setOpenForgotPasswordModal,
    openChangeEmailModal,
    setOpenChangeEmailModal,
    changeEmailContext,
    setChangeEmailContext,
    openPartnerModal,
    setOpenPartnerModal,
    openClientSetupModal,
    setOpenClientSetupModal,
    clientSetupContext,
    setClientSetupContext,
    handleOpenModal,
    handleCloseModal,
    isModalOpen,
    selectedCard,
    openModal,
    closeModal,
    closeAll,
  };
}
